import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { BreakpointsService } from '@core/services/breakpoints/breakpoints.service';
import { trackEventWithAtInternet } from '@wizbii/tracking';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-youth-info-center-card-address',
  templateUrl: './youth-info-center-card-address.component.html',
  styleUrls: ['./youth-info-center-card-address.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class YouthInfoCenterCardAddressComponent {
  @Input() youthInfoCenterStreet!: string;
  @Input() youthInfoCenterZipCode!: string;
  @Input() youthInfoCenterCity!: string;
  @Input() youthInfoCenterMapLink!: string;
  @Input() linkAriaLabel!: string;

  trackEvent = trackEventWithAtInternet;

  get isMobile$(): Observable<boolean> {
    return this.breakpoints.isMobile$;
  }

  trackByLine(_: number, line: string): string {
    return line;
  }

  constructor(private readonly breakpoints: BreakpointsService) {}
}

@NgModule({
  imports: [CommonModule, MatIconModule],
  exports: [YouthInfoCenterCardAddressComponent],
  declarations: [YouthInfoCenterCardAddressComponent],
})
export class YouthInfoCenterCardAddressModule {}
